import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import classnames from 'classnames';
import SideBarIcon from '@/components/pages/center/imgs/SideBarIcon';
import styles from '@/styles/pages/center/sideBar.module.scss';

function SideBar() {
  const router = useRouter();
  const pathNameArr = router.pathname.split('/').filter((x) => x !== '');
  const { t } = useTranslation('pages');
  const keyPrefix = pathNameArr[0]?.replace('App', '') || '';
  const textObj = t(keyPrefix, { returnObjects: true });
  const combineNav = typeof textObj === 'object' ? Object.keys(textObj).filter((x) => x !== 'header') : [];

  return (
    <div className={styles.tabs}>
      {combineNav.map((section) => {
        const linkBuilder = ['', pathNameArr[0]].concat(section).join('/');
        return (
          <Link key={section} href={linkBuilder}>
            <div className={classnames(styles.tabBlock, { [styles.active]: pathNameArr.includes(section) })}>
              <div className={styles.tabRow}>
                <SideBarIcon icon={section} />
                <span>
                  {t(`${keyPrefix}.${section}.header`)}
                </span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}

export default SideBar;
